const NAME = "STRIPE";

const promo = (store) => store[NAME].promo || {};

export default {
  promo,
};
